module.exports = __webpack_public_path__ + "img/1F1F8-1F1F1.9a1a344b.svg";